module.exports = __webpack_public_path__ + "img/image-placeholder.8e23d73b.svg";